import { AppContext } from "@/services/AppContext/appContext";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
} from "@/shadcn/components/ui/alert-dialog";
import { setSessionDismissedUpdateAccount } from "@/utils/tokens.util";
import React, { useContext } from "react";

const DialogUpdateProfile: React.FC = () => {
  const { setUserDismissedUpdateAccount } = useContext(AppContext);

  function handleClose() {
    setSessionDismissedUpdateAccount(true);
    setUserDismissedUpdateAccount(true);
  }

  return (
    <AlertDialog open={true} aria-label="Update Profile Dialog">
      <AlertDialogContent className="">
        <div className="flex flex-col items-center justify-center space-y-4">
          <h2 className="text-lg font-semibold">Update Profile</h2>
          <p className="">
            Please verify and update your details in the profile page
          </p>
          <AlertDialogCancel onClick={() => handleClose()} className="mt-4">
            Close
          </AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DialogUpdateProfile;
